import React from 'react';
import FrontPage from './pages/frontPage/frontPage.js'
import ProjectPage from './pages/project/project.js';
import {
  Route,
  Redirect,
  Switch,
} from "react-router-dom";
import { Router } from 'react-router';
import history from './utils/history'
import ContactUs from './pages/contactUs/contactUs.js'
import Projects from './pages/projects/projects.js'
import About from './pages/about/about'
import Position from './pages/positions/position'


function App() {
  return (
    <Router history={history}>
      <div>
        <Switch>
          <Route exact path='/' component={FrontPage}/>
          <Route exact path='/projects/:id' component={ProjectPage}/>
          <Route exact path='/contact' component={ContactUs}/>
          <Route exact path='/projects' component={Projects}/>
          <Route exact path='/about/:detail' component={About}/>
          <Route exact path='/about' render={() => <Redirect to='/about/aboutUs' />} />
          <Route exact path='/positions/:position' component={Position}/>
          <Route render={() => <Redirect to='/' />} />
        </Switch>
      </div>
    </Router>
  );
}

export default App;
